module.exports = __webpack_public_path__ + "img/app-google-play.42285900.svg";